import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "location-control-body map-object" };
const _hoisted_2 = {
    id: "location-control-map",
    ref: "location-control-map",
    class: "location-control-map"
};
import { useLocationControl } from '@/use/useLocationControl';
import DialogHeader from '@/components/Dialog/DialogHeader.vue';
import { nextTick, onMounted, } from 'vue';
import { useRouter } from 'vue-router';
export default /*@__PURE__*/ _defineComponent({
    __name: 'index',
    setup(__props) {
        // 페이지: 출발도착관제
        const router = useRouter();
        const { headerTitle, init, handleClickNo, checkIsHideCloseBtn, injectQSToPinia, printMap, } = useLocationControl();
        /**
         * 배차 주문 변경
         */
        const changeLocationControlOrder = async (_orderId = '') => {
            await router.replace({
                query: {
                    orderId: _orderId,
                },
            }).catch(() => { });
            await nextTick();
            await injectQSToPinia();
            printMap();
        };
        onMounted(() => {
            window.changeLocationControlOrder = changeLocationControlOrder;
            init();
        });
        return (_ctx, _cache) => {
            const _component_v_card = _resolveComponent("v-card");
            return (_openBlock(), _createBlock(_component_v_card, { class: "popup-css-location-control-dialog" }, {
                default: _withCtx(() => [
                    _createVNode(DialogHeader, {
                        title: _unref(headerTitle),
                        "on-cancel": _unref(handleClickNo),
                        "is-hide-close-btn": _unref(checkIsHideCloseBtn)
                    }, null, 8 /* PROPS */, ["title", "on-cancel", "is-hide-close-btn"]),
                    _createElementVNode("div", _hoisted_1, [
                        _createElementVNode("div", _hoisted_2, [
                            _createCommentVNode(" 네이버 지도 ")
                        ], 512 /* NEED_PATCH */)
                    ])
                ]),
                _: 1 /* STABLE */
            }));
        };
    }
});
